import { render, staticRenderFns } from "./AddExpenseCategory.vue?vue&type=template&id=49312a01&"
import script from "./AddExpenseCategory.vue?vue&type=script&lang=js&"
export * from "./AddExpenseCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddExpenseCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports